<template>
  <div v-if="comType == 'UI'">
    <div
      :style="{
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
        'background-color': backgroundColor,
        color: textColor,
      }"
    >
      <el-carousel
        indicator-position="none"
        :direction="direction"
        height="30px"
        arrow="never"
      >
        <el-carousel-item v-for="(item, index) in noticeList" :key="index">
          <h3
            :style="{
              'font-size': `${fontSize}px`,
            }"
          >
            <img v-if="imgUrl" :src="imgUrl" draggable="false" />
            <span>{{ item.noticeText }}</span>
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="图片">
          <customUpload :imageUrl.sync="imgUrlValue"></customUpload>
          <div class="tip">建议尺寸：40*40px</div>
        </el-form-item>
        <div class="collapse-content">
          <el-collapse :value="activeName" size="small">
            <draggable v-model="noticeListValue">
              <el-collapse-item
                :name="index"
                :key="index"
                v-for="(item, index) in noticeListValue"
              >
                <template slot="title">
                  <el-form-item :label="`公告${index + 1}`">
                    <div class="collapse-title" @click.stop>
                      <jumpConfig :jumpLink.sync="item.jumpLink"></jumpConfig>
                      <el-button
                        type="default"
                        size="mini"
                        circle
                        @click.stop="deleteNotice(index)"
                      >
                        <i class="el-icon-delete"></i
                      ></el-button>
                    </div>
                  </el-form-item>
                </template>
                <el-form-item label="内容">
                  <el-input
                    type="text"
                    placeholder="请输入公告内容"
                    size="small"
                    v-model="item.noticeText"
                    maxlength="20"
                    show-word-limit
                    clearable
                    style="width: 280px"
                  ></el-input>
                </el-form-item>
              </el-collapse-item>
            </draggable>
          </el-collapse>
          <div class="foot">
            <el-button type="default" size="small" plain @click="addNotice"
              >添加公告</el-button
            >
          </div>
        </div>
      </div>
      <div>
        <el-form-item label="展示方式">
          <el-radio-group v-model="directionValue" size="small">
            <el-radio-button label="horizontal">跑马灯</el-radio-button>
            <el-radio-button label="vertical">上下翻滚</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="字体颜色">
          <el-color-picker
            v-model="textColorValue"
            :predefine="predefineColors"
            size="small"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-radio-group v-model="fontSizeValue" size="small">
            <el-radio-button :label="12">小</el-radio-button>
            <el-radio-button :label="14">中</el-radio-button>
            <el-radio-button :label="18">大</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="上间距">
          <div class="slider-block">
            <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="下间距">
          <div class="slider-block">
            <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="左间距">
          <div class="slider-block">
            <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="右间距">
          <div class="slider-block">
            <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="上内间距">
          <div class="slider-block">
            <el-slider v-model="paddingTopValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="下内间距">
          <div class="slider-block">
            <el-slider v-model="paddingBottomValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="左内间距">
          <div class="slider-block">
            <el-slider v-model="paddingLeftValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="右内间距">
          <div class="slider-block">
            <el-slider v-model="paddingRightValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import customUpload from "@/components/appltDecoration/customUpload";
import jumpConfig from "@/components/appltDecoration/jumpConfig";
import { comMixins } from "@/mixins/comMixins";

export default {
  mixins: [comMixins],
  name: "comNotice",
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    noticeList: {
      type: Array,
      default: () => {
        return [
          {
            noticeText: "我是公告",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
            },
          },
        ];
      },
    },
    direction: {
      type: String,
      default: "horizontal",
    },
    imgUrl: {
      type: String,
      default: "",
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
    paddingTop: {
      type: Number,
      default: 0,
    },
    paddingRight: {
      type: Number,
      default: 0,
    },
    paddingBottom: {
      type: Number,
      default: 0,
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    backgroundColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    },
    textColor: {
      type: String,
      default: "rgb(51, 51, 51)",
    },
  },
  computed: {
    imgUrlValue: {
      get() {
        return this.imgUrl;
      },
      set(val) {
        this.$emit(`update:imgUrl`, val);
      },
    },
    noticeListValue: {
      get() {
        return this.noticeList;
      },
      set(val) {
        this.$emit(`update:noticeList`, val);
      },
    },
    titleTextValue: {
      get() {
        return this.titleText;
      },
      set(val) {
        this.$emit(`update:titleText`, val);
      },
    },
    directionValue: {
      get() {
        return this.direction;
      },
      set(val) {
        this.$emit(`update:direction`, val);
      },
    },
    textColorValue: {
      get() {
        return this.textColor;
      },
      set(val) {
        this.$emit(`update:textColor`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
    fontSizeValue: {
      get() {
        return this.fontSize;
      },
      set(val) {
        this.$emit(`update:fontSize`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
    paddingTopValue: {
      get() {
        return this.paddingTop;
      },
      set(val) {
        this.$emit(`update:paddingTop`, val);
      },
    },
    paddingRightValue: {
      get() {
        return this.paddingRight;
      },
      set(val) {
        this.$emit(`update:paddingRight`, val);
      },
    },
    paddingBottomValue: {
      get() {
        return this.paddingBottom;
      },
      set(val) {
        this.$emit(`update:paddingBottom`, val);
      },
    },
    paddingLeftValue: {
      get() {
        return this.paddingLeft;
      },
      set(val) {
        this.$emit(`update:paddingLeft`, val);
      },
    },
  },
  components: {
    customUpload,
    jumpConfig,
    draggable,
  },
  data() {
    return {
      activeName: [0],
    };
  },
  methods: {
    addNotice() {
      this.activeName.push(this.noticeListValue.length);
      this.noticeListValue.push({
        noticeText: "",
        jumpLink: {
          type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
          remark: "",
        },
      });
    },
    deleteNotice(index) {
      this.$confirm(`确定删除[公告${index + 1}]吗?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.noticeListValue.splice(index, 1);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.el-carousel {
  h3 {
    padding: 5px;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    font-weight: 400;
    img:not(.notFull img) {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      vertical-align: top;
      display: inline-block;
      border-right: 1px solid #ccc;
      padding-right: 10px;
    }
    span {
      display: inline-block;
      white-space: nowrap;
    }
  }
}
</style>
